import React, {useEffect, useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import BoxHeader from "../components/box-header";
import {useTranslate} from "../../system/useTranslate";
import Icon from "../../system/components/icon";
import {useUpdateEffect} from "primereact/hooks";
import {InputText} from "primereact/inputtext";
import SelectMember from "./components/select-member";
import {useSelector} from "react-redux";
import {MultiSelect} from "primereact/multiselect";
import SelectZofinoDateTime from "./components/select-zofino-datetime";
import {Button} from "primereact/button";
import {useDeliverable} from "../../models/deliverable/use-deliverable";
import UploadDialog from "../components/upload-dialog";
import {fileThumbnail} from "../../system/utils";
import SelectType from "./components/select-type";
import {Dropdown} from "primereact/dropdown";
import SelectProject from "./components/select-project";
import {resolveUrl} from "../../system/app-config";
import {Message} from "primereact/message";
import {unixSecondsToDate} from "./deliverable-date";
import {RichTextEditor} from "../../system/components/rich-text";

function DeliverableDialog({visible, setVisible, onSubmit, payload, mobile = false, error = "", submitting = false}) {

    const [deliverableData, setDeliverableData] = useState();

    useEffect(()=>{
        if (visible){
            setDeliverableData({
                project: payload?.projectData,
                ...(payload?.deliverableData || {}),
            });
        }
    },[visible])

    return (
        <Dialog showHeader={false} pt={{root:()=>({className:"h-30rem"}),content:()=>({className:"p-0 border-round h-full"})}} className={mobile ? "shabnam-font w-full md:w-6 mx-2 md:mx-0 rtl h-30rem" : "w-6 rtl h-30rem"} visible={visible} onHide={()=>{if (!submitting) setVisible(false)}}>
            <div className="flex h-full">
                <DeliverableForm
                    setVisible={setVisible}
                    onSubmit={onSubmit}
                    deliverableData={deliverableData}
                    setDeliverableData={setDeliverableData}
                    projectLocked={Boolean(payload?.projectData)}
                    mobile={mobile}
                    error={error}
                    externalSubmitting={submitting}
                />
            </div>
        </Dialog>
    );
}

function DeliverableForm({setVisible, onSubmit, deliverableData, setDeliverableData, projectLocked, mobile, error, externalSubmitting}) {
    const translate = useTranslate();
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [uploadDialogVisible, setUploadDialogVisible] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [validationError, setValidationError] = useState("");
    const submitLockRef = useRef(false);

    useEffect(() => {
        setDeliverableData({...deliverableData, workspace:workspaceMembershipData?.workspace.id})
    }, [workspaceMembershipData]);



    // useUpdateEffect(() => {
    //      console.log(deliverableData)
    //
    //  }, [deliverableData]);

     // const createDeliverable = async ()=>{
     //     let _data = await deliverable.createDeliverable();
     //     setVisible(false)
     // }

    const submit = async () => {
        if (submitting || externalSubmitting || submitLockRef.current) return;
        if (mobile && !String(deliverableData?.title || "").trim()) {
            setValidationError(translate("mobile.quick-create.milestone-title-required"));
            return;
        }
        if (mobile && !deliverableData?.project) {
            setValidationError(translate("mobile.quick-create.milestone-project-required"));
            return;
        }
        setValidationError("");
        submitLockRef.current = true;
        setSubmitting(true);
        try {
            await onSubmit?.({...deliverableData, workspace:workspaceMembershipData.workspace.id, startAt:unixSecondsToDate(deliverableData?.startAt), doneAt:unixSecondsToDate(deliverableData?.doneAt), assignee:deliverableData?.assignee, project:deliverableData?.project?.id, attachments:deliverableData?.attachments?.map(attachment=>attachment.id)});
        } finally {
            submitLockRef.current = false;
            setSubmitting(false);
        }
    };

     return(
         <form className="flex-1 flex flex-column h-full" onSubmit={(event) => {
             event.preventDefault();
             submit();
         }}>
             <BoxHeader className="p-3" title={translate("create-deliverable")} left={<Icon icon="mi mi:close" onClick={()=>{setVisible(false)}} className="cursor-pointer text-400"/>}/>
             {(validationError || error) && <Message className="mx-3 text-xs" severity="error" text={validationError || error}/>}
             <InputText className="border-none shadow-none bg-transparent text-xl" placeholder={translate("deliverable-title-placeholder")} value={deliverableData?.title||""} onChange={(e)=>{setDeliverableData({...deliverableData, title:e.target.value})}}/>
             <DeliverableToolbar
                 setDeliverableData={setDeliverableData}
                 deliverableData={deliverableData}
                 projectLocked={projectLocked}
             />
             <div className="px-3 pb-2 flex-1">
                 <RichTextEditor placeholder={translate("deliverable-description")} value={deliverableData?.description||""} onChange={(html)=>{setDeliverableData((current) => ({...current, description: html}))}} minHeight="6rem"/>
             </div>
             {deliverableData?.attachments&&(<div className="flex flex-wrap align-items-center w-full surface-200 p-1 gap-1">{deliverableData?.attachments.map(attachment=>(<div className="flex align-items-center gap-1 surface-100 border-round p-1">{fileThumbnail(attachment.name, resolveUrl(attachment.formats?.thumbnail?.url || attachment.url), "40px", true)}<span className="px-1 text-2xs">{attachment.name}</span></div>))}</div>)}
             <div className="w-full surface-100 flex justify-content-between align-items-center p-2">
                 <div className="flex align-items-center gap-3 px-2">
                     <Icon icon="mi mi:attach_file" className="text-400 text-lg" onClick={()=>{setUploadDialogVisible(true)}}/>
                     <Icon icon="mi mi:label" className="text-400 text-lg" onClick={()=>{}}/>
                     <Icon icon="mi mi:group_add" className="text-400 text-lg" onClick={()=>{}}/>
                     <Icon icon="mi mi:settings" className="text-400 text-lg" onClick={()=>{}}/>
                 </div>
                 <div className="flex align-items-center gap-2">
                     <Button type="button" label={translate("cancel")} disabled={submitting || externalSubmitting} className="text-xs p-button-text p-button-secondary border-round-2xl p-2 border-none shadow-none" onClick={()=>{setVisible(false)}}/>
                     <Button type="submit" label={translate("create-deliverable")} disabled={submitting || externalSubmitting} loading={submitting || externalSubmitting} className="text-xs p-2 border-none shadow-none border-round-2xl px-3" />
                 </div>
             </div>
             <UploadDialog visible={uploadDialogVisible} setVisible={setUploadDialogVisible} updateContentType={(e)=>{setDeliverableData({...deliverableData, attachments:[...deliverableData.attachments??[], ...e]})}} />
         </form>
     )
 }

function DeliverableToolbar({deliverableData, setDeliverableData, projectLocked}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();
    function ItemTemplate(option) {
        return(
            <div className="flex align-items-center border-noround justify-content-between px-2 cursor-pointer">
                <div className="flex gap-2 align-items-center">
                    <div className="flex flex-column">
                        {option?(
                            <span className="text-xs">{option?.title}</span>
                        ):(
                            <div className="flex align-items-center gap-1">
                                <Icon icon="mi mi:folder_open" className="text-lg"/>
                                <span className="text-xs">{translate("project")}</span>
                            </div>

                        )}
                    </div>
                </div>

                {/*{option.value>0&&<i className="pi pi-chevron-left text-xs"/>}*/}
            </div>
        )
    }

    return(
     <div className="flex flex-wrap gap-2 align-items-center px-3">
         <div className="border-1 border-300 border-dashed border-round-3xl px-2">
             <SelectMember selectedMember={deliverableData?.assignee} onChange={(membership)=>{setDeliverableData({...deliverableData, assignee: membership})}} members={workspaceMembershipData?.workspace.workspace_memberships || []} />
         </div>
         <div className="border-1 border-300 border-dashed border-round-3xl px-2">
             <SelectProject readOnly={projectLocked} onChange={(e)=>{setDeliverableData({...deliverableData, project:e})}} projects={workspaceMembershipData?.workspace?.projects} selectedProject={deliverableData?.project}/>
         </div>
         <div className="border-1 border-300 border-dashed border-round-3xl px-2">
             <SelectZofinoDateTime range selectedDateTime={{end:deliverableData?.doneAt, start:deliverableData?.startAt}} onChange={(e)=>{setDeliverableData({...deliverableData, doneAt:e.end?.toUnix(), startAt:e.start?.toUnix()})}}/>
         </div>

     </div>
    )
}

export default DeliverableDialog;
